import { queryOptions, useQuery } from '@tanstack/react-query';

import { teamApi } from '../api/team-api';

import { teamKeys } from './team-keys';

export function membersQueryOptions() {
  return queryOptions({ queryKey: teamKeys.members(), queryFn: teamApi.listMembers });
}

export function useMembers() {
  return useQuery(membersQueryOptions());
}
